import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationOverviewViewModel from '@/ViewModels/Controls/PrincipalHistorizationOverviewViewModel';
import PrincipalHistorizationOverview from '@/Controls/PrincipalHistorizationOverview';

export default class PrincipalHistorizationOverviewFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private PrincipalHistorizationOverviewViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationOverviewViewModel>('PrincipalHistorizationOverviewViewModel');
    private PrincipalHistorizationOverview = ComponentManager.getControl<typeof PrincipalHistorizationOverview>('PrincipalHistorizationOverview');

    /**
     * @override
     */
    viewModel: PrincipalHistorizationOverviewViewModel;

    public constructor(params: any) {
        super(params);

        this.labelPosition = this.paramOrDefault('None');
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        
        this.viewModel = new this.PrincipalHistorizationOverviewViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            xml: this.context.genericObject.getObservable(this.detailViewItem.name)
        });

        this.control = new this.PrincipalHistorizationOverview(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('PrincipalHistorizationOverview', PrincipalHistorizationOverviewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('RADPresentation.DefaultViewExtensions.UIComponents.PrincipalHistorizationOverview', PrincipalHistorizationOverviewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');